export default __webpack_public_path__ + "./images/pa.d46b1fc0.png";